import { Phone, Mail, Clock, ShieldCheck } from "lucide-react";
import { CONTACT } from "../../data/content";
import { Reveal } from "../motion/Motion";
import SurveyForm from "./SurveyForm";

export default function Contact() {
  const contactItems = [
    { icon: Phone, label: "Telefon", value: CONTACT.phone, href: CONTACT.phoneHref, testid: "contact-phone" },
    { icon: Mail, label: "E-mail", value: CONTACT.email, href: CONTACT.emailHref, testid: "contact-email" },
    { icon: Clock, label: "Nyitvatartás", value: CONTACT.hours, testid: "contact-hours" },
  ];

  return (
    <section id="kapcsolat" data-testid="contact-section" className="bg-[#F3F4F6] py-20 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-10 max-w-2xl md:mb-16">
          <Reveal>
            <p className="mb-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-brand-accent">
              <span className="h-px w-10 bg-brand-accent" />
              Kapcsolat
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading text-3xl font-extrabold leading-[1.08] tracking-tight text-brand-primary sm:text-4xl lg:text-5xl">
              Kérjen díjmentes felmérést még ma
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 max-w-xl text-brand-primary/60">
              Válaszoljon néhány rövid kérdésre, és személyre szabott ajánlatot készítünk
              Önnek. Az egész űrlap kitöltése kevesebb mint egy percet vesz igénybe.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <Reveal className="lg:col-span-7">
            <SurveyForm />
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-5">
            <div className="sticky top-24 flex flex-col bg-brand-primary p-6 text-white sm:p-8 md:p-10">
              <ShieldCheck size={40} strokeWidth={1.5} className="text-brand-accent" />
              <h3 className="mt-6 font-heading text-2xl font-bold">
                Beszéljünk otthona szigeteléséről
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-white/65">
                Több mint két évtized tapasztalatával állunk rendelkezésére. A helyszíni
                felmérés díjmentes és kötelezettség nélküli.
              </p>

              <div className="mt-10 space-y-6">
                {contactItems.map((item) => {
                  const Icon = item.icon;
                  const content = (
                    <div className="flex items-start gap-4">
                      <span className="grid h-11 w-11 shrink-0 place-items-center bg-white/10 text-brand-accent">
                        <Icon size={18} />
                      </span>
                      <div>
                        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/45">
                          {item.label}
                        </div>
                        <div className="mt-1 font-medium text-white">{item.value}</div>
                      </div>
                    </div>
                  );
                  return item.href ? (
                    <a key={item.label} href={item.href} data-testid={item.testid} className="block transition-opacity hover:opacity-80">
                      {content}
                    </a>
                  ) : (
                    <div key={item.label} data-testid={item.testid}>{content}</div>
                  );
                })}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
